export const CONVERSAYION_MESSAGE_TYPES = {
  AI: 'ai',
  HUMAN: 'human',
  AI_THINKING: 'ai_thinking',
  ERROR: 'error',
  UNKNOWN: 'unknown',
  SYSTEM: 'system',
  TOOL_EXECUTION: 'tool_execution',
  FUNCTION_EXECUTION: 'function_execution'
};

export default CONVERSAYION_MESSAGE_TYPES;